import type { Messages } from "./es";

// Ton courtois ("vous") dans toute l'interface.
const fr = {
  // ── Commun ─────────────────────────────────────────────────────────
  commonPoweredBy: "Propulsé par",
  commonManageReservationLink: "Gérer ma réservation",
  commonRestaurantConfirmAvailability:
    "Le restaurant confirmera la disponibilité.",
  commonConnectionErrorShort: "Erreur de connexion",
  commonConnectionErrorRetry: "Erreur de connexion. Veuillez réessayer.",
  commonConnectionErrorLater:
    "Erreur de connexion. Veuillez réessayer plus tard.",
  commonPeopleOne: "{n} personne",
  commonPeopleOther: "{n} personnes",
  commonPeopleShortOne: "{n} pers.",
  commonPeopleShortOther: "{n} pers.",
  commonCalendarWeekdays: ["L", "M", "M", "J", "V", "S", "D"],
  commonTimeSuffix: " h",

  commonMenuShowDescription: "Voir la description",
  commonMenuHideDescription: "Masquer la description",
  commonMenuAllGuestsLabel: "Pour toute la table ({count} personnes)",
  commonMenuTotalLabel: "Sélectionné : {total} sur {count} personnes",
  commonMenuExceedsPartySize:
    "Le menu sélectionné dépasse le nombre de personnes.",
  commonMenuSummaryItem: "{qty}× {name}",

  // ── App.tsx (réservation de table) ────────────────────────────────────
  appOrgNotFoundHeading: "Restaurant introuvable",
  appOrgNotFoundFallback: "Restaurant introuvable",
  appOrgLoadNetworkError: "Erreur lors du chargement des données du restaurant",
  appOrgLoadGenericError:
    "Impossible de charger les informations du restaurant",

  appSuccessHeadingLargeGroup: "Demande reçue !",
  appSuccessHeadingPending: "Demande envoyée !",
  appSuccessHeadingConfirmed: "Réservation confirmée !",
  appSuccessBodyLargeGroup:
    "Votre demande de groupe chez {name} a été enregistrée. Le restaurant vous contactera.",
  appSuccessBodyPending:
    "Votre réservation chez {name} est en attente d'approbation. Nous vous préviendrons dès que le restaurant l'aura confirmée.",
  appSuccessBodyConfirmed: "Votre réservation chez {name} a été enregistrée.",
  appSuccessEmailNotePending:
    "Vous recevrez l'avis de confirmation à {email}",
  appSuccessEmailNoteConfirmed:
    "Vous recevrez un e-mail de confirmation à {email}",
  appNewReservationButton: "Faire une autre réservation",

  appPartySizeLabel: "Nombre de personnes",
  appLargeGroupButton: "Grand groupe (+{threshold} personnes)",
  appLargeGroupQuestion: "Vous êtes combien ?",
  appLargeGroupPlaceholder: "ex. 25",

  appSelectDayLabel: "Choisissez un jour",
  appShowMoreDates: "Voir plus de dates",

  appSelectRoomLabel: "Choisissez une salle",
  appNoRoomsAvailable: "Aucune salle disponible ce jour-là.",

  appSelectTimeLabel: "Choisissez une heure",
  appDefaultClosedReason: "Jour de fermeture",
  appNoSlotsAvailable: "Aucun créneau disponible",
  appDefaultShiftLunch: "DÉJEUNER",
  appDefaultShiftDinner: "DÎNER",
  appNoTablesAvailable: "Aucune table disponible",
  appContinueButton: "Continuer",

  appMenuQuestionHeading: "Souhaitez-vous un menu ?",
  appMenuNoThanksButton: "Non merci",
  appMenuYesButton: "Oui",
  appMenuListHeading: "Choisissez votre menu",
  appMenuSummaryHeading: "Votre menu :",

  appSummaryModify: "Modifier",
  appPhoneLabel: "Téléphone *",
  appPhonePlaceholder: "06 12 34 56 78",
  appNameLabel: "Prénom *",
  appNamePlaceholder: "Votre prénom",
  appLastNameLabel: "Nom *",
  appLastNamePlaceholder: "Votre nom",
  appEmailLabel: "E-mail *",
  appEmailPlaceholder: "vous@email.com",
  appEmailInvalid: "Veuillez saisir une adresse e-mail valide",
  appNotesLabel: "Commentaires (facultatif)",
  appNotesPlaceholderDefault:
    "Préférence de table, anniversaire, chaise haute, mobilité réduite, etc.",

  appAcceptTermsPrefix: "J'accepte les",
  appTermsLinkLabel: "Conditions Générales",
  appAcceptPrivacyPrefix: "J'accepte la",
  appPrivacyLinkLabel: "Politique de Confidentialité",
  appSpendNotice:
    "{restaurant} conserve le montant de l'addition de votre réservation dans votre fiche client. Vous pouvez vous y opposer à tout moment. Plus d'informations :",
  appMarketingCheckbox: "Recevoir les offres et actualités du restaurant",

  appLargeGroupSummary: "Grand groupe ({people})",

  appBackButton: "Retour",
  appSubmitButton: "Réserver",
  appSubmitting: "Envoi en cours...",
  appSubmitErrorFallback: "Erreur lors de la création de la réservation",

  appFullCalendarTitle: "Choisissez une date",

  // ── ReservationManage.tsx (gérer la réservation depuis le lien) ──────
  manageLoading: "Chargement de votre réservation...",
  manageNotFoundHeading: "Réservation introuvable",
  manageFetchErrorFallback: "Réservation introuvable",
  manageConfirmErrorFallback: "Erreur lors de la confirmation",
  manageCancelErrorFallback: "Erreur lors de l'annulation",
  manageModifyErrorFallback: "Erreur lors de la modification de la réservation",

  statusPending: "En attente de confirmation",
  statusConfirmed: "Confirmée",
  statusCancelled: "Annulée",
  statusCompleted: "Terminée",
  statusNoShow: "Absence",
  statusCancelledByEstablishment: "Annulée par le restaurant",

  manageGoogleEventTitle: "Réservation chez {name}",
  manageGoogleDetailsIntro: "Réservation pour {people}",
  manageGoogleDetailsCode: "Code : {code}",
  manageGoogleDetailsNotes: "Notes : {notes}",

  manageConfirmSuccessHeading: "Réservation confirmée !",
  manageConfirmSuccessBody: "Nous vous attendons le {date} à {time}",
  manageAddToGoogleCalendar: "Ajouter à Google Agenda",

  manageCancelSuccessHeading: "Réservation annulée",
  manageCancelSuccessBodyLine1: "Votre réservation a bien été annulée.",
  manageCancelSuccessBodyLine2: "Nous espérons vous revoir bientôt.",

  manageModifySuccessHeading: "Réservation modifiée",
  manageModifySuccessBodyLine1: "Votre demande de modification a été envoyée.",
  manageModifySuccessBodyLine2: "Vous recevrez une confirmation sous peu.",

  manageCancelledByRestaurantTitle: "Le restaurant a annulé cette réservation",
  manageCancelledByRestaurantBody:
    "Nous sommes désolés pour la gêne occasionnée. N'hésitez pas à réserver un autre jour ou à contacter directement le restaurant.",
  manageCancellationReasonLabel: "Motif indiqué par le restaurant",

  manageYourReservationHeading: "Votre réservation",
  manageRoomLabel: "Salle : {roomName}",
  manageCodeLabelBlock: "Code de réservation",
  manageNotesLabel: "Notes",

  manageMenuHeading: "Votre menu",
  manageMenuChangeButton: "Changer",
  manageMenuNoneSelected: "Vous n'avez ajouté aucun menu à votre réservation.",
  manageMenuNotEditableNotice:
    "Le choix du menu peut être modifié jusqu'à la veille de la réservation.",
  manageMenuModalTitle: "Changer de menu",
  manageMenuSaveErrorFallback: "Erreur lors de l'enregistrement du menu",

  managePendingApprovalBannerTitle:
    "En attente d'approbation du restaurant.",
  managePendingApprovalBannerBody:
    "Dès qu'il l'aura confirmée, vous recevrez un avis et pourrez confirmer votre présence ici.",
  manageConfirmDisabledTitle:
    "Disponible dès que le restaurant approuve votre demande",
  manageConfirmDisabledLabel:
    "Confirmer votre présence (en attente d'approbation)",
  manageConfirmButton: "Confirmer votre présence",

  managePendingChangeBannerTitle:
    "Vous avez déjà une demande de modification en attente.",
  managePendingChangeBannerFooter:
    "Le restaurant l'examinera et vous répondra sous peu.",
  managePendingChangeDisabledTitle:
    "Vous avez déjà une demande de modification en cours d'examen",
  managePendingChangeDisabledLabel: "Demande de modification en attente",
  manageModifyButton: "Modifier la réservation",
  manageCancelButton: "Annuler la réservation",

  managePendingSummaryDate: "date : {date}",
  managePendingSummaryTime: "heure : {time}",
  managePendingSummaryPeople: "personnes : {n}",

  manageWhatsAppButton: "Contacter par WhatsApp",

  manageModalConfirmTitle: "Confirmer votre présence",
  manageModalConfirmQuestion:
    "Confirmez-vous votre présence à votre réservation chez {name} ?",
  manageModalConfirmBack: "Retour",
  manageModalConfirmSubmit: "Confirmer",

  manageModalCancelTitle: "Annuler la réservation",
  manageModalCancelWarningTitle: "Êtes-vous sûr(e) ?",
  manageModalCancelWarningBody:
    "Cette action est irréversible. Si vous annulez, vous perdrez votre réservation chez {name}.",
  manageModalCancelKeep: "Conserver",
  manageModalCancelSubmit: "Annuler",

  manageModalEditTitle: "Modifier la réservation",
  manageModalEditDateLabel: "Date",
  manageModalEditTimeLabel: "Heure",
  manageModalEditPartyLabel: "Nombre de personnes",
  manageModalEditSummaryPrefix: "Nouvelle réservation :",
  manageModalEditSummaryAt: "à",
  manageModalEditSummaryFor: "pour",
  manageModalEditCancel: "Annuler",
  manageModalEditSubmit: "Enregistrer les modifications",

  // ── ConfirmReservation.tsx (confirmation depuis l'e-mail/WhatsApp) ───
  confirmLoading: "Confirmation de votre réservation...",
  confirmErrorHeading: "Confirmation impossible",
  confirmAlreadyCancelled: "Cette réservation a déjà été annulée.",
  confirmGenericErrorFallback: "Erreur lors de la confirmation de la réservation",

  confirmAwaitingHeading: "En attente d'approbation",
  confirmAwaitingBody:
    "Votre réservation est en attente d'approbation du restaurant. Dès qu'il l'aura confirmée, vous recevrez un avis par e-mail ou WhatsApp et pourrez la reconfirmer ici.",
  confirmCodeLabelInline: "Code de réservation :",

  confirmAlreadyHeading: "Réservation déjà confirmée",
  confirmSuccessHeading: "Réservation confirmée !",
  confirmAlreadyBody: "Votre réservation était déjà confirmée.",
  confirmSuccessBody: "Merci d'avoir confirmé votre présence.",
  confirmFooterText: "Au plaisir de vous accueillir. Bon appétit !",

  classesPickDay: "Choisissez le jour",
  classesWeekPrev: "Semaine précédente",
  classesWeekNext: "Semaine suivante",
  classesCountOne: "{n} cours",
  classesCountOther: "{n} cours",
  classesNoClassesThisDay: "Pas de cours ce jour-là",
  classesSeatsLeft: "{n} places sur {total}",
  classesFull: "Complet",
  classesMinutes: "{n} min",
  classesTeacher: "Prof. {name}",
  classesPeople: "Personnes",
  classesName: "Nom et prénom",
  classesEmail: "Email",
  classesPhone: "Téléphone (facultatif)",
  classesMarketing:
    "Je souhaite recevoir les actualités de cet établissement",
  classesSubmit: "Confirmer la réservation",
  classesSubmitting: "Réservation…",
  classesFieldsError: "Vérifiez le nom et l'email",
  classesOnlyLeft: "Il ne reste que {n} places pour ce cours",
  classesFullNow:
    "Ce cours vient de se remplir. Choisissez un autre horaire ou un autre jour.",
  classesSuccessTitle: "Réservation confirmée !",
  classesSuccessCode: "Code de réservation",
  classesSuccessEmailSent:
    "Nous vous avons envoyé un email avec les détails et le lien pour gérer votre réservation.",
  classesNewBooking: "Faire une autre réservation",
  classesLoadError:
    "Impossible de charger les informations. Veuillez réessayer.",
  classesCompanyToggle:
    "Je réserve pour le compte d'une entreprise (hôtel, agence…)",
  classesCompanyName: "Nom de l'entreprise ou de l'hôtel",
} satisfies Messages;

export default fr;
